/* import React from 'react'
import './PageFooter.css'

const Footer = () => {
	return (
		<div>
			<footer
				className='pageFooter'
				style={{ marginTop: '4rem', paddingTop: '4rem', paddingBottom: '4rem' }}
			>
				<p>High School Ball Hockey League</p>
				<p>
					Questions about Stats & Standings?{' '}
					<a href='mailto:matt@shireystatsandstandings.com'> Email Us!</a>
				</p>
			</footer>
		</div>
	)
}

export default Footer */
import React from 'react'
import './Footer.css'

const Footer = () => {
	return (
		// <div style={{ backgroundColor: '#ee2e30' }}>
		<div style={{ backgroundColor: '#1e154d' }}>
			<footer>
				<div>
					<div className='row'>
						<div className='col text-center'>
							<h1
								className='font-weight-light text-capitalize p-3'
								style={{ color: 'white', textShadow: 'black 2px 2px 2px' }}
							>
								Memorial Park Ball Hockey Club
							</h1>
							{/* <h4
								className='font-weight-bold font-italic'
								style={{ color: 'white' }}
							>
								Growing the game, one school at a time.
							</h4> */}
							<div className='py-3'>
								<a
									href='https://www.facebook.com/profile.php?id=61550024107732&mibextid=LQQJ4d'
									target='_blank'
									style={{ color: 'white' }}
								>
									<i
										className='fa fa-facebook-square fa-4x mx-3'
										style={{ textShadow: 'black 2px 2px 2px' }}
									></i>
								</a>
							</div>
							<p
								className='py-4 m-0 copyright'
								style={{ color: 'white', backgroundColor: '#686868' }}
							>
								A Web Application by{' '}
								<a
									//href='https://www.shireystatsandstandings.com/#'
									href='https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'
									target='_blank'
									style={{ color: 'white' }}
								>
									Shirey Stats and Standings, LLC
								</a>
							</p>
							<p
								className='m-0 copyright'
								style={{
									paddingTop: '0rem',
									paddingBottom: '2.5rem',
									color: 'white',
									backgroundColor: '#686868',
								}}
							>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										gap: '15px',
										flexWrap: 'wrap',
									}}
								>
									<a
										href='https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'
										target='_blank'
										rel='noreferrer'
									>
										<img
											src='https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg'
											alt='Download on the App Store'
											className='store-badge'
										/>
									</a>

									<a
										href='https://play.google.com/store/apps/details?id=app.web.shireytournamenttracker.app132474&hl=en_US'
										target='_blank'
										rel='noreferrer'
									>
										<img
											src='https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg'
											alt='Get it on Google Play'
											className='store-badge'
										/>
									</a>
								</div>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
